
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e/[id]",
      function () {
        return require("private-next-pages/e/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e/[id]"])
      });
    }
  